export type VersionSignal = {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => number;
};

let version = 0;
const listeners = new Set<() => void>();

export const actualCostRefreshSignal: VersionSignal & { notify: () => void } = {
  notify: () => {
    version += 1;
    for (const listener of listeners) listener();
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  getSnapshot: () => version,
};
